export * from './validation';
export * from './parserXlsx';

export const handleCopy = async (str: string) => {
	await navigator.clipboard.writeText(str);
};
